import ProcedureDTO from '@src/adapters/dto/procedure/ProcedureDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  filter: string;
  pageSize: number;
  currentPage: number;
}

interface Result {
  procedures: ProcedureDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/procedure/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindProcedures = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindProceduresLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindProcedures;
